/* eslint newline-before-return: "error" */
import { deleteSkillMap } from '../../../../Api/request/skillMap';
import UseAxios from '../../../../Api/http/http';
import {
  ENABLE_DISABLE_ROLE_DIALOG,
  AUTHENTICATION_FAILED,
} from '../../../../Constants/strings';

export const handleDeleteAction = async (
  selectedItem,
  setFilteredList,
  setLevelFilteredList,
  setIsDialogOpen,
  handleSnackbar,
  setAnchorEl,
) => {
  try {
    const response = await UseAxios(deleteSkillMap(selectedItem));

    if (response.data.status !== 200) {
      const errorStatus = response.data.response.status;

      handleCloseAction(setIsDialogOpen);
      handleSnackbar(
        errorStatus === 401
          ? AUTHENTICATION_FAILED
          : ENABLE_DISABLE_ROLE_DIALOG.OOPS_TRY_AGAIN,
        'warning',
        'enable-disable-warning-snackbar',
      );
      throw new Error('Failed to delete skill map');
    }

    setFilteredList((prevRows) => {
      const updatedRows = prevRows.filter(
        (row) => row.skillMapId !== selectedItem,
      );

      return updatedRows;
    });

    setLevelFilteredList((prevRows) => {
      const updatedRows = prevRows.filter(
        (row) => row.skillMapId !== selectedItem,
      );

      handleCloseAction(setIsDialogOpen);

      handleSnackbar(
        'Skill is deleted',
        'success',
        'enable-disable-success-snackbar',
      );

      return updatedRows;
    });
    setAnchorEl(null);
  } catch (error) {
    console.error(error);
  }
};

export const handleCloseAction = (setIsDialogOpen) => {
  setIsDialogOpen(false);
};
